var version = {
    "name":      "dativery",
    "buildDateCode": "20260914-174510",
    "buildDate": "Mon Sep 14 2026 17:45:10 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260914-174510",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;